import { GLOBALS } from "config";

export function getAdminUrl(path: string): string {
  let protocol = "https:";
  if (typeof window !== "undefined") {
    protocol = window.location.protocol;
  }
  return protocol + "//" + GLOBALS.DASHBOARD_DOMAIN_PREFIX + GLOBALS.DASHBOARD_DOMAIN + path;
}
